import React, { useEffect, useState } from 'react';

import "./ImgStore.scss";
import { useBeam } from '@randajan/bifrost/client/react';
import { imgsBeam } from '../../assets/beams/imgsBeam';
import { Img } from '../Img/Img';

const buildImgUrl = (imgId, ext, version)=>{
    const url = `/store/img/${imgId}.${ext}`;
    return version ? `${url}?v=${version}` : url;
}

export const ImgStore = (props)=>{
    const { src, className, noFetch, forceSvg, allowCors, normalizeSvg, ...selfProps } = props;
    const { data:imgs, status } = useBeam(imgsBeam);
    const [imgStatus, setImgStatus] = useState("pending");

    const [imgId, ext="png"] = (src?.split(".") || []);


    const wrapClassName = ["ImgStore", className].filter(Boolean).join(" ");

    if (status === "pull" || !imgs?.[imgId]) { 
        return <span {...selfProps} className={wrapClassName} data-status={imgStatus}/>
    }

    const { version, fileSize, pressRatio } = imgs[imgId];

    const preload = (ext === "png" && fileSize >= 512 && pressRatio <= 0.2);

    const passProps = {
        noFetch,
        forceSvg,
        allowCors,
        normalizeSvg,
    }

    return (
        <span {...selfProps} className={wrapClassName} data-status={imgStatus}>
            {preload && <Img {...passProps} src={buildImgUrl(imgId, "webp", version)} className="placeholder" transition/>}
            <Img {...passProps} src={buildImgUrl(imgId, ext, version)} onStatus={setImgStatus}/>
        </span>
    );
}
